import { useEffect } from 'react';
import createNetworkingClient from 'utils/networking-client';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const mockOptOut = window.location.search.includes('mock-opt-out');

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useEffectOnce = (fn) => useEffect(fn, []);

export const optOutReason = {
  uninterestedInSportType: 'uninterested_in_sport_type',
  uninterestedInAthlete: 'uninterested_in_athlete',
  notUseful: 'not_useful',
  other: 'other'
};

export const optOutApiCall = (activityId) =>
  mockOptOut
    ? sleep(1000)
    : createNetworkingClient().post(
        `/discovery/activities/${activityId}/opt_out?discovery_strategy=NEW_REG_FEED`
      );

export const feedbackApiCall = (activityId, reason) => {
  const params = new URLSearchParams({
    discovery_strategy: 'NEW_REG_FEED',
    opt_out_reason: reason
  });

  return mockOptOut
    ? sleep(800)
    : createNetworkingClient().post(
        `/discovery/activities/${activityId}/opt_out?${params}`
      );
};

export const undoApiCall = (activityId, reason) => {
  const params = new URLSearchParams({
    discovery_strategy: 'NEW_REG_FEED',
    ...(reason && { opt_out_reason: reason })
  });

  return mockOptOut
    ? sleep(800)
    : createNetworkingClient().post(
        `/discovery/activities/${activityId}/delete_opt_out?${params}`
      );
};
